const statusInstrument = [
  {
    label: "Valid",
    instruments: [
      {
        "instrumentName": "dxh600",
        "value": 0
      }
    ]
  },
  {
    label: "NotAvailable",
    instruments: [
      {
        "instrumentName": "Cobas u411",
        "value": 0
      },
      {
        "instrumentName": "DXH 600",
        "value": 0
      }
    ]
  }
]

export { statusInstrument }
